import { Stack, Tooltip, Typography } from '@mui/material';
import { ConditionBindingMinimal } from '@retail/calculus/types';
import { useMarkupTFunction } from '@retail/markup/i18n';
import { InheritedIcon } from '@shared/custom-icons';
import { LevelChip } from './ConditionApproval';

interface Props {
    bindingInfo: ConditionBindingMinimal;
}

export const ActiveMarkupTooltip = ({ bindingInfo }: Props) => {
    const t = useMarkupTFunction();
    return (
        <Tooltip title={<Stack gap={2}>
            <Typography variant="subtitle2">{t('markup.activeMarkupOrigin')}</Typography>
            <Stack flexDirection="row" alignItems="center" gap={2}>
                <Typography variant="body2">{t('markup.level')}:</Typography>
                <LevelChip height={28} active bindingType={bindingInfo.bindingType} />
            </Stack>
            <Stack flexDirection="row" gap={1}>
                <Typography variant="body2">{t('markup.levelOrItemName')}:</Typography>
                <Typography variant="subtitle2">{bindingInfo.bindingTargetName}</Typography>
            </Stack>
        </Stack>}>
            <Stack>
                <InheritedIcon fontSize="small" />
            </Stack>
        </Tooltip>
    );
};